const sessionsFilteredBySearchPhrase = state => searchPhrase => {
	if (!searchPhrase) return state.sessions.items.reverse()
	return state.sessions.items.reverse().filter( i => i.name.toLowerCase().search(searchPhrase.toLowerCase()) != -1 )
}

export default {
	sessionsFilteredBySearchPhrase,
}